//hook
import { useApi } from '../../hooks/useApi';
import { useState } from 'react';

//mui
import { DialogProps } from '@mui/material/Dialog';

//mui icons
import StarIcon from '@mui/icons-material/Star';
import WeekendOutlinedIcon from '@mui/icons-material/WeekendOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


//translate
import { useTranslation } from 'react-i18next';

//type
import { MyCarType } from '../../api/Host/type/AddCarType';



interface myCarCardProps {
  setOpenAddCar:(value: {open:boolean,scrollType: DialogProps['scroll']}) => void
  setSelectedCar: (selectedCar?: MyCarType) => void
  element: MyCarType
  setShowCarOffers: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void
  setOpenDeleteConfirmation: (openDeleteConfirmation: boolean) => void
}

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;

const MyCarCard = ({setOpenAddCar, setSelectedCar, element, setShowCarOffers, setOpenDeleteConfirmation}: myCarCardProps) => {
  const {t} = useTranslation()

  return (
    <div className="rounded-2xl border border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 group relative">
      <div
      className='px-2 py-1 rounded-lg !absolute !top-1 !right-1 !bg-red-500 !text-white cursor-pointer z-10'
      onClick={() => {setOpenDeleteConfirmation(true); setSelectedCar(element);}}>
          <DeleteOutlineIcon/>
      </div>
      <div className="relative h-40 w-full group overflow-hidden rounded-t-[15px]">
        <img
            className="h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-[1.5]"
            src={`${storageURL}/${element.primary_images[0]?.url}`}
            alt="car_photo"
        />
        </div>
      <div className="p-3 mt-3">
        <p className="font-[600] truncate">{element.brand.name} - {element.model}</p>
        <div className="text-[#7F7F7F] text-sm">
          <div className="flex items-center gap-2 mt-2">
            <StarIcon  className="!text-[#FF8F3A]"/>
            <p>{element.avg_rate}</p>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <WeekendOutlinedIcon/>
            <p>{element.seating_capacity} {t("seats")}</p>
          </div>
          <div>
            {
              element.is_daily !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.daily_price))} / {t("day")}</p>
                </div>
              :
              element.is_weekly !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.weekly_price))} / {t("week")}</p>
                </div>
              :
              element.is_monthly !== 0 
              ?
                <div className={`flex items-center gap-2 mt-2`}>
                  <MonetizationOnOutlinedIcon/>
                  <p>{Math.trunc(Number(element.monthly_price))} / {t("month")}</p>
                </div>
              :
              <></>
            }
          </div>
        </div>
        <div className='flex justify-between mt-2'>
          <div 
          onClick={()=>{setSelectedCar(element); setOpenAddCar({open: true, scrollType: "paper"})}} 
          className='cursor-pointer flex items-center gap-2 border-[1px] border-solid border-[#0073E6] text-[#0073E6] px-3 rounded-md'>
            <EditIcon className='!text-[15px]'/>
            <p>{t("edit")}</p>
          </div>
          <div
          onClick={()=>{setSelectedCar(element); setShowCarOffers({open: true, scrollType: "paper"})}}
          className='cursor-pointer flex gap-2 border-[1px] border-solid border-paretnerColor text-paretnerColor px-3 rounded-md'>
            <p>{t("view_offers")}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MyCarCard